import axios from "axios";

// Visitor-pages domain (e.g. casequoter.com) — loaded once, cached for the tab.
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "lander-domain-v1";

let state = (() => {
  try { return JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch { return null; }
})();
let pending = null;

export const landerSettings = () => state;

export function loadLanderDomain() {
  if (!pending) {
    pending = axios.get(`${API}/public/lander-domain`, { timeout: 4000 })
      .then((r) => {
        state = r.data;
        try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch { /* private mode */ }
        return state;
      })
      .catch(() => { state = state || { enabled: false }; return state; });
  }
  return pending;
}

export const landerHosts = (s = state) => (s?.domain ? [s.domain, `www.${s.domain}`] : []);
export const isLanderHost = (s = state) => landerHosts(s).includes(window.location.hostname);
export const landerOrigin = (s = state) => (s?.enabled && s.domain ? `https://${s.domain}` : null);

// Full link to a visitor page: on the landing domain once it's switched on.
export const publicLink = (path) => `${landerOrigin() || window.location.origin}${path}`;
export const publicOrigin = () => landerOrigin() || window.location.origin;

// Admin link to a visitor page: live pages open on the landing domain; drafts stay here (they need your login).
export const pageLink = (path, live = true) => (live ? publicLink(path) : path);
